import React from "react";
import ScrollAnimation from "../../hooks/ScrollAnimation";
import contactInfo from "../data/contactInfo";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import { useTranslation } from "react-i18next";

export default function GetInTouchSection() {
  const { t } = useTranslation();
  const items = t("contact_section.get_in_touch.items", { returnObjects: true }) || [];
  UseScrollAnimation();

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollAnimation direction="up" delay={0.1}>
          <div className="text-center mb-16">
            <h2
              className="text-3xl md:text-4xl font-extrabold tracking-tight text-gray-900 mb-4 js-scroll fade-top"
              style={{
                background: "linear-gradient(90deg,#0f172a 0%,#334155 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {t("contact_section.get_in_touch.title")}
            </h2>
            <p
              className="text-lg text-gray-600 max-w-2xl mx-auto js-scroll fade-btm"
            >
              {t("contact_section.get_in_touch.subtitle")}
            </p>
          </div>
        </ScrollAnimation>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {items.map((item, index) => (
            <ScrollAnimation key={index} direction="up" delay={index * 0.08}>
              <div
                className="group relative rounded-2xl p-[1px] transition-all duration-300 js-scroll fade-left"
              >
                {/* Gradient border wrapper */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-blue-500 via-indigo-500 to-cyan-400 opacity-70 blur-[10px] transition-opacity duration-300 group-hover:opacity-100" />
                <div className="relative z-10 rounded-2xl bg-white/80 backdrop-blur-xl p-8 shadow-[0_10px_25px_rgba(2,6,23,0.08)] ring-1 ring-black/5">
                  <div className="mx-auto mb-6 grid place-items-center">
                    <div className="grid place-items-center w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-50 to-indigo-50 ring-1 ring-black/5">
                      <div className="text-blue-600 group-hover:scale-110 transition-transform duration-300">
                        {contactInfo[index]?.icon}
                      </div>
                    </div>
                  </div>
                  <h3 className="text-xl font-extrabold text-gray-900 text-center mb-3 tracking-tight">
                    {item.title}
                  </h3>
                  <div className="space-y-1.5 mb-4 text-center">
                    {(item.details || []).map((detail, idx) => (
                      <p key={idx} className="text-gray-700 font-medium">
                        {detail}
                      </p>
                    ))}
                  </div>
                  <p className="text-gray-500 text-sm text-center leading-relaxed">
                    {item.description}
                  </p>

                  {/* Hover CTA underline */}
                  <div className="mt-6 flex items-center justify-center">
                    <span className="h-[2px] w-16 rounded-full bg-gradient-to-r from-blue-400 via-indigo-400 to-cyan-400 scale-x-0 origin-center transition-transform duration-300 group-hover:scale-x-100" />
                  </div>

                  {/* subtle tilt shine */}
                  <div className="pointer-events-none absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition duration-300">
                    <div className="absolute -inset-8 bg-gradient-to-tr from-transparent via-white/20 to-transparent rotate-12 blur-xl" />
                  </div>
                </div>
              </div>
            </ScrollAnimation>
          ))}
        </div>
      </div>
    </section>
  );
}
